import { TariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/tariff/tariff.model';
import { DisplayColumnDef } from '@tanstack/react-table';

import { TariffListActionsCell } from './tariff-list-actions.cell';
import { TariffListActionsHeader } from './tariff-list-actions.header';

export const TariffListActionsColumn: DisplayColumnDef<TariffModel, unknown> = {
  id: 'actions',
  enableSorting: false,
  enableHiding: false,
  header: TariffListActionsHeader,
  cell: TariffListActionsCell,
};
